module.exports = __webpack_public_path__ + "img/backage_img.1088c78f.jpg";